import React, { Component } from "react";
import { UnSortableTableHeader } from "../../components/table/unsortable-table-header";

export default class QsrCommentaryTableHeader extends Component {
    static Layout = [

        { column: "commentKey", width: 1, name: "QSR Commentary Key" },
        { column: "reportArea", width: 2, name: "Report Area" },
        { column: "specialEvent", width: 2, name: "Event type" },
        { column: "fldDate", width: 2, name: "Date" },
        { column: "comment", width: 3, name: "Comment" },
        { column: "action", width: 2, name: "Action To Improve" },

    ];
    render() {
        return (
            <UnSortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={QsrCommentaryTableHeader.Layout} />

        )
    }
}